import OBase from './OBase';
import * as Geometry from '../geometry';

export default class DotProduct extends OBase {
  update () {
    let aValTree = this.getVector3Input('Vector A');
    let bValTree = this.getVector3Input('Vector B');
    let uValTree = this.getBoolInput('Unitize');

    let dOutput = this.getGenericObjectOutput('Dot product');

    let dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(aValTree);
    dataTrees.push(bValTree);
    dataTrees.push(uValTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var dOutTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let aVal = outDataTrees[0].branches[i][j];
        let bVal = outDataTrees[1].branches[i][j];
        var uVal = outDataTrees[2].branches[i][j];

        var val = 0;

        if (uVal) {
          let aValN = new THREE.Vector3(aVal.x, aVal.y, aVal.z);
          aValN.normalize();
          let bValN = new THREE.Vector3(bVal.x, bVal.y, bVal.z);
          bValN.normalize();

          val = aValN.dot(bValN);
        } else {
          val = aVal.dot(bVal);
        }

        dOutTree.add(val, outDataTrees[0].paths[i]);
      }
    }

    dOutput.value = dOutTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/DotProduct.js